import React from "react";
import { BadgeCheckIcon, HardHatIcon, FileCheck2Icon as UsersIcon, RepeatIcon } from "lucide-react";
import { Reveal } from "../shared/Reveal";

// [Trust] Facts published on oceansideliving.com.au. Confirm experience wording and BC registration before launch.
const stats = [{
  value: "30+ years",
  label: "Directors’ combined WA building experience",
  icon: HardHatIcon
}, {
  value: "BC 103813",
  label: "Registered WA builder",
  icon: BadgeCheckIcon
}, {
  value: "Fixed price",
  label: "Fixed-price building contracts, detailed quote before you sign",
  icon: UsersIcon
}, {
  value: "Repeat client",
  label: "Sohail & Danielle are building their second with us",
  icon: RepeatIcon
}];
export function TrustBar() {
  return <section aria-label="Why clients trust Oceanside Living" className="bg-paper pb-4 pt-12 md:pt-14" data-id="element-389" data-mp="2rlabz69pzquz">
      <div className="mx-auto max-w-site px-5 md:px-10" data-id="element-390" data-mp="23uwpdv9wmk7s">
        <ul className="grid grid-cols-2 gap-y-10 lg:grid-cols-4" data-id="element-391" data-mp="1yxxx7i9swnc8">
          {stats.map((stat, index) => <li key={stat.value} className={`px-3 text-center lg:px-6 ${index > 0 ? "lg:border-l lg:border-line" : ""} ${index % 2 === 1 ? "border-l border-line lg:border-l" : ""}`} data-id="element-392" data-mp="2rsausesnjyr1" data-mpi={index}>
              <Reveal delay={index * 0.04} data-id="element-393" data-mp="31hko1xz8fngq">
                <stat.icon className="mx-auto h-6 w-6 text-ocean" aria-hidden="true" data-id="element-394" data-mp="31huetns3pynh" />
                <p className="mt-3 font-heading text-[24px] font-semibold tracking-tight text-charcoal md:text-[30px]" data-id="element-395" data-mp="36f3zkq4jpm4z">{stat.value}</p>
                <p className="mx-auto mt-1 max-w-[220px] text-[14px] leading-snug text-slate md:text-[15px]" data-id="element-396" data-mp="28urkl7ugka31">{stat.label}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}